import { roles } from "../../Mappings";
import {
  GenericDateIsoStringInputComponent,
  GenericDisabledTextInputComponent,
  GenericFreeTextInputComponent,
  SelectRoleIdInputComponent,
  SelectVendorIdInputComponent,
} from "./InputComponents";

export const userDefinition = {
  id: {
    displayName: "ID",
    value: "",
    type: "string",
    displayValue: (entity) => String(entity.id),
    inputComponent: GenericDisabledTextInputComponent,
    isValid: (entity) => true,
  },

  userName: {
    displayName: "Username",
    value: "",
    type: "string",
    displayValue: (entity) => String(entity.userName),
    inputComponent: GenericFreeTextInputComponent,
    isValid: (entity) => /^(\w|\d){3,15}$/.test(entity.userName),
  },

  roleId: {
    displayName: "Role",
    value: "",
    type: "string",
    displayValue: (entity) => String(roles[entity.roleId]),
    inputComponent: SelectRoleIdInputComponent,
    isValid: (entity) => String(entity.roleId) !== "",
  },

  vendorId: {
    displayName: "Vendor ID",
    value: "",
    type: "string",
    displayValue: (entity) => String(entity.vendorId),
    inputComponent: SelectVendorIdInputComponent,
    // isValid: (entity) => {
    //   if (
    //     entity.roleId === roles.tollAdmin ||
    //     entity.roleId === roles.tollManager
    //   ) {
    //     return entity.vendor === "Toll";
    //   } else {
    //     return entity.vendor !== "";
    //   }
    // },
    isValid: (entity) => entity.vendor !== "",
  },

  firstName: {
    displayName: "First Name",
    value: "",
    type: "string",
    displayValue: (entity) => String(entity.firstName),
    inputComponent: GenericFreeTextInputComponent,
    isValid: (entity) => entity.firstName !== "",
  },

  lastName: {
    displayName: "Last Name",
    value: "",
    type: "string",
    displayValue: (entity) => String(entity.lastName),
    inputComponent: GenericFreeTextInputComponent,
    isValid: (entity) => entity.lastName !== "",
  },

  email: {
    displayName: "Email Address",
    value: "",
    type: "string",
    displayValue: (entity) => String(entity.email),
    inputComponent: GenericFreeTextInputComponent,
    isValid: (entity) => /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(entity.email),
  },

  startDate: {
    displayName: "Start Date",
    displayValue: (entity) =>
      entity.startDate ? entity.startDate.split("T")[0] : "",
    inputComponent: GenericDateIsoStringInputComponent,
    isValid: (entity) => {
      if (entity.startDate && entity.endDate) {
        return entity.startDate <= entity.endDate;
      } else {
        return true;
      }
    },
  },

  endDate: {
    displayName: "End Date",
    displayValue: (entity) =>
      entity.endDate ? entity.endDate.split("T")[0] : "",
    inputComponent: GenericDateIsoStringInputComponent,
    isValid: (entity) => {
      if (entity.startDate && entity.endDate) {
        return entity.startDate <= entity.endDate;
      } else {
        return true;
      }
    },
  },
};

export const columns = [
  "id",
  "userName",
  "roleId",
  "vendorId",
  "firstName",
  "lastName",
  "email",
  "startDate",
  "endDate",
];

export const defaultUser = {
  id: 0,
  userName: "",
  roleId: undefined,
  vendorId: "",
  firstName: "",
  lastName: "",
  email: "",
  startDate: undefined,
  endDate: undefined,
};
